import { TASK_TYPES } from '../ContentLists/TaskList/constants'
import AbsenceRequestDetails from '../absence-request-details'
import MonthlySheetDetails from '../monthly-sheet-details'
import SecureConnectionDetails from '../secure-connection-details'
import ShareUserData from '../share-user-data'

export const getTaskDetailsComponent = (taskType: string) => {
  switch (taskType) {
    case TASK_TYPES.absenceRequest:
      return AbsenceRequestDetails
    case TASK_TYPES.monthlySheet:
      return MonthlySheetDetails
    case TASK_TYPES.secureConnection:
      return SecureConnectionDetails
    case TASK_TYPES.shareUserData:
      return ShareUserData
    default:
      return null
  }
}
